import { z } from 'zod';
export const InlineChartTypeSchema = z.enum(['line', 'bar', 'area']);
export const InlineChartSeriesSchema = z.object({
    label: z.string().min(1).max(60),
    data: z.array(z.number().finite().nullable()).max(100),
});
export const InlineChartSpecSchema = z.object({
    type: InlineChartTypeSchema,
    title: z.string().max(120).optional(),
    x: z.array(z.string().max(40)).max(100),
    series: z.array(InlineChartSeriesSchema).min(1).max(4),
    yLabel: z.string().max(40).optional(),
    stacked: z.boolean().optional(),
});
//# sourceMappingURL=chat-chart.js.map